module.exports = __webpack_public_path__ + "img/advantages_monte_carlo_simulation.png";